export default __webpack_public_path__ + "static/media/sendMoney_root_background.265c2f9a.jpg";